import React from "react";
// import { ChevronLeft, ArrowRightShort, Check2Square, XSquare } from 'react-bootstrap-icons';
import { Container, Col, Row, Card, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IconClose } from "../../../../assets/icons";

function UnSuccessPayment(props) {
  return (
    <>
      <Container className="my-auto" style={{ maxWidth: "500px" }}>
        <Card className="rounded-4 ">
          <Card.Body>
            <div className="bg-danger justify-content-center rounded-3 text-center py-2">
              <span className="text-white"> پرداخت ناموفق بود </span>
            </div>
            <Row className="justify-content-center mt-3 ">
              <Col
                xs="12"
                className=" d-flex justify-content-center mt-4 pt-2 large-icons"
              >
                <span>
                  <IconClose fillColor="red" />
                  {/* <XSquare size={40} className='text-danger' /> */}
                </span>
              </Col>
              <Col xs="12" className=" d-flex justify-content-center mt-3 ">
                <span className="text-danger fw-bold">
                  {" "}
                  پرداخت شما ناموفق بود
                </span>
              </Col>
            </Row>

            <Row className="mt-4">
              <Col xs="12" className="">
                <Alert variant="danger"> {props.errorText}</Alert>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        <div></div>

        {/* <Row className='mt-4 mb-5'>
                    <Col xs='12' className=' d-flex justify-content-center align-items-center '>
                        <Link to="/payment" >  <Button size='sm' className='py-1 px-4' variant='outline-secondary'>
                            تایید
                        </Button>
                        </Link  >
                    </Col>
                </Row> */}
      </Container>
    </>
  );
}

export default UnSuccessPayment;
